/* Hermi Habesha — Theme JS */

/* Mobile nav toggle */
(function() {
  var menuBtn = document.getElementById('mobile-menu-btn');
  var navLinks = document.querySelector('.nav-links');
  if (menuBtn && navLinks) {
    menuBtn.addEventListener('click', function() {
      var open = navLinks.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }
})();

/* Live cart count update via AJAX */
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    })
    .catch(function() {});
}

updateCartCount();
